import { configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { combineReducers } from 'redux';
import AccountDeletionRequestSlice from "../features/accountDeleteionRequest/AccountDeletionRequestSlice";
import AreaSlice from "../features/areacode/slice";
import ClassSlice from "../features/class/ClassSlice";
import ConsentSlice from "../features/consent/ConsentSlice";
import DisciplineSlice from "../features/discipline/DisciplineSlice";
import EditRequestSlice from "../features/editRequest/EditRequestSlice";
import EditUserRequestSlice from "../features/editRequest/user/EditUserRequestSlice";
import EventSlice from "../features/event/EventSlice";
import CompanySlice from "../features/company/CompanySlice";
import EmailTemplateSlice from "../features/emailTemplates/EmailTemplateSlice";
import EventTypeSlice from "../features/eventType/EventTypeSlice";
import MembershipSlice from "../features/membership/MembershipSlice";
import NewsLetterSlice from "../features/newsletter/NewsLetterSlice";
import PaymentSlice from "../features/payment/PaymentSlice";
import RegisterSlice from "../features/register/RegisterSlice";
import SizeSlice from "../features/sizes/slice";
import MainSlice from "../features/slice";
import StudentSlice from "../features/student/studentslice";
import SubAdminSlice from "../features/subAdmin/SubAdminSlice";
import TeacherSlice from "../features/teacher/TeacherSlice";
import tncSlice from "../features/tnc/tncSlice";
import UserSlice from "../features/user/UserSlice";
import BookingSlice from "./../features/booking/BookingSlice";
import SmsSlice from "./../features/manageSMS/SmsSlice";
import WalletHistorySlice from "../features/user/WalletHistorySlice";
import subdomainReducer from '../features/subdomainSlice';
import authReducer from '../features/auth/authSlice';
import subscriptionReducer from '../features/subscription/SubscriptionSlice';

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['auth'],
};

const rootReducer = combineReducers({
  user: UserSlice,
  teacher: TeacherSlice,
  event: EventSlice,
  company: CompanySlice,
  emailTemplate: EmailTemplateSlice,
  membership: MembershipSlice,
  class: ClassSlice,
  register: RegisterSlice,
  booking: BookingSlice,
  accountDeletionRequest: AccountDeletionRequestSlice,
  main: MainSlice,
  area: AreaSlice,
  size: SizeSlice,
  student: StudentSlice,
  eventType: EventTypeSlice,
  payment: PaymentSlice,
  discipline: DisciplineSlice,
  subAdmin: SubAdminSlice,
  consent: ConsentSlice,
  tnc: tncSlice,
  edit: EditRequestSlice,
  editUser: EditUserRequestSlice,
  newsletter: NewsLetterSlice,
  sms: SmsSlice,
  walletHistory: WalletHistorySlice,
  subdomain: subdomainReducer,
  auth: authReducer,
  subscription: subscriptionReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }),
});

export const persistor = persistStore(store);
